import { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import Typography from "../../Utility/Typography";

const PendingTasks = ({ dataValues: dataValuesProp }) => {
  const dataValues = Array.isArray(dataValuesProp) ? dataValuesProp : [];
  const hasData = dataValues.length > 0;
  const total = dataValues.reduce((a, b) => a + b.value, 0);
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!hasData) return;
    const chart = new Chart(canvasRef.current, {
      type: "doughnut",
      data: {
        labels: dataValues.map((d) => d.name),
        datasets: [
          {
            data: dataValues.map((d) => d.value),
            backgroundColor: dataValues.map((d) => d.color),
            borderWidth: 0,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "70%",
        plugins: {
          legend: { display: false },
        },
      },
    });

    return () => chart.destroy();
  }, [dataValues, hasData]);

  if (!hasData) {
    return (
      <div className="py-10 text-center">
        <Typography variant="text2" className="text-gray-500">
          No data
        </Typography>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-[100px] justify-center">
      <div className="relative w-72 h-72">
        <canvas ref={canvasRef} />
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <Typography variant="span2" className="!text-2xl !font-bold !text-gray-800" component="p">
            {total}
          </Typography>
          <Typography
            variant="span2"
            className="!text-xs !text-gray-500 !text-center !leading-tight"
            component="p"
          >
            Total work items
          </Typography>
        </div>
      </div>
      <div className="space-y-2 text-sm">
        {dataValues.map((item, i) => (
          <div key={i} className="flex items-center gap-2">
            <Typography
              variant="span2"
              className="w-3 h-3 rounded-sm"
              component="span"
              style={{ backgroundColor: item.color }}
            ></Typography>

            <Typography variant="span2" className="text-gray-700" component="span">
              {item.name}
            </Typography>

            <Typography variant="span2" className="ml-auto text-gray-500" component="span">
              {item.value}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PendingTasks;
